/**
 * Any alphabet character can be used as a hotkey expect for the letter 's'
 * which is reserved for opening the Shortcut Keys Menu.
 */
export type Letter =
  | 'a'
  | 'b'
  | 'c'
  | 'd'
  | 'e'
  | 'f'
  | 'g'
  | 'h'
  | 'i'
  | 'j'
  | 'k'
  | 'l'
  | 'm'
  | 'n'
  | 'o'
  | 'p'
  | 'q'
  | 'r'
  | 't'
  | 'u'
  | 'v'
  | 'w'
  | 'x'
  | 'y'
  | 'z';

export interface LetterOption {
  description: string;
  hotkeyHandler: (event: KeyboardEvent) => void;
  hotkeyCondition?: (event: KeyboardEvent) => boolean;
}

export type LetterOptions = {
  [key in Letter]?: LetterOption;
};

// TODO: Next iteration of component should be able to account for combo hotkeys
export interface HotkeyOptions {
  shortcuts: LetterOptions;
  shortcutMenuEnabledCondition?: (event: KeyboardEvent) => boolean;
}

export interface OptionsShortcut {
  key: string;
  description: string;
}
